import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { LoadingSpinner } from './shared/LoadingSpinner';
import { toast } from 'sonner';

/**
 * Componente que protege rotas de upgrade/checkout
 * - Bloqueia viewers (que não podem gerenciar e não têm licença expirada)
 * - Permite admins (can_manage_organization === true)
 * - Permite usuários com licença expirada (podem renovar)
 */
interface ProtectedUpgradeRouteProps {
  children: React.ReactNode;
}

export const ProtectedUpgradeRoute: React.FC<ProtectedUpgradeRouteProps> = ({ children }) => {
  const { user } = useAuth();
  const [isAllowed, setIsAllowed] = useState<boolean | null>(null);

  useEffect(() => {
    const checkAccess = async () => {
      try {
        // Se pode gerenciar organização, é admin - tem acesso
        if (user?.can_manage_organization) {
          setIsAllowed(true);
          return;
        }

        // Verificar se é viewer (role_description contém "Reader")
        if (user?.role_description && (user.role_description.includes('Reader') || user.role_description.includes('visualiza'))) {
          toast.error('Viewers não podem gerenciar planos.');
          setIsAllowed(false);
          return;
        }

        // Caso contrário, é usuário com licença expirada - pode acessar para renovar
        setIsAllowed(true);
      } catch (error) {
        setIsAllowed(false);
      }
    };

    checkAccess();
  }, [user]);

  if (isAllowed === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" text="Verificando acesso..." />
      </div>
    );
  }

  if (!isAllowed) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};
